<template>
  <img v-if="image" :src="image" alt="" width="18" height="18" class="showcase-avatar" />
  <span v-else class="showcase-avatar showcase-avatar--initials">{{ initials }}</span>
</template>

<script>
  import { computed } from 'vue';

  import avatarCas from '@/assets/img/login/avatar-cas.svg';
  import avatarSander from '@/assets/img/login/avatar-sander.svg';

  const AVATARS = {
    cas: avatarCas,
    sander: avatarSander,
  };

  export default {
    name: 'ShowcaseAvatar',
    props: {
      person: {
        type: String,
        required: true,
      },
      initials: {
        type: String,
        default: 'BO',
      },
    },
    setup(props) {
      const image = computed(() => AVATARS[props.person]);
      return { image };
    },
  };
</script>

<style scoped lang="scss">
  .showcase-avatar {
    flex-shrink: 0;
    &--initials {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      border-radius: 9px;
      background-color: var(--showcase-blue-bg);
      color: var(--showcase-primary);
      font-size: 8px;
      font-weight: 600;
      line-height: 10px;
    }
  }
</style>
